import { createRouter, createWebHistory } from 'vue-router';
import store from '@/VueWorking/store.js';

import Login from '@/VueWorking/Pages/Login.vue';
import Index from '@/VueWorking/Pages/Index.vue';
import Error403 from '@/VueWorking/Pages/Errors/Error403.vue';

// const store = this.$store;

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/login', component: Login },
        { path: '/', component: Index, meta: { requiresAuth: true } },
        { path: '/errors/403', component: Error403 },
    ],
});

// router.beforeEach((to, from, next) => {
//     // Check if the route requires authentication and if the user is authenticated
//     if (to.matched.some(record => record.meta.requiresAuth) && !store.isAuthenticated) {
//         next('/login'); // redirect to login page
//     } else {
//         next(); // proceed to route
//     }
// });

router.beforeEach((to, from, next) => {
    const isApiRequest = to.matched.some(record => record.path.startsWith('/api')); // Проверка на API-запрос
    const isLoginRoute = to.matched.some(record => record.path.startsWith('/login')); // Проверка на API-запрос
    // const isAccess = to.matched.some(record => record.path.startsWith('/login'));
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // next('/login');
    // console.log(isApiRequest);
    // console.log(requiresAuth);
    // console.log(store.state.isAuthenticated);
    if (requiresAuth && !parseFloat(localStorage.authenticated??0)){
        next('/login');
    } else {
        next();
    }
});

export default router;